import { render, staticRenderFns } from "./DownloadBilling.vue?vue&type=template&id=0c4ad858&scoped=true&"
import script from "./DownloadBilling.vue?vue&type=script&lang=js&"
export * from "./DownloadBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ad858",
  null
  
)

export default component.exports